import { z } from 'zod';
// §5.3 spec técnica. Importes en CLP enteros; cantidades pueden tener decimales.
export const UnidadCodigo = z.string().min(1).max(20);
export const ConceptoCodigo = z.string().regex(/^[A-Z0-9_]{2,40}$/);
export const LaborCodigo = z.string().regex(/^[A-Z0-9_]{2,30}$/);
export const TarifaUnitaria = z.object({ unidad: UnidadCodigo, precio: z.number().int().positive() });
export const TarifaDia = z.object({ valor_dia: z.number().int().positive() });
export const TarifaHora = z.object({ valor_hora: z.number().int().positive() });
export const TarifaDiaMeta = z.object({
    valor_dia: z.number().int().positive(),
    meta: z.number().positive(),
    unidad: UnidadCodigo,
    precio_sobre_meta: z.number().int().nonnegative(),
});
export const BonoMultiplicador = z.object({
    factor: z.number().gt(1).lte(3),
    base_concepto: ConceptoCodigo,
});
export const BonoMonto = z.object({
    tramos: z.array(z.object({ desde: z.number(), monto: z.number().int() })).min(1),
});
/** Parámetros de tarifa discriminados por tipo de cálculo. */
export const ParametrosTarifa = z.discriminatedUnion('tipo_calculo', [
    z.object({ tipo_calculo: z.literal('tarifa_unitaria'), parametros: TarifaUnitaria }),
    z.object({ tipo_calculo: z.literal('dia'), parametros: TarifaDia }),
    z.object({ tipo_calculo: z.literal('hora'), parametros: TarifaHora }),
    z.object({ tipo_calculo: z.literal('dia_meta'), parametros: TarifaDiaMeta }),
]);
export function esquemaParametros(tipo) {
    switch (tipo) {
        case 'tarifa_unitaria':
            return TarifaUnitaria;
        case 'dia':
            return TarifaDia;
        case 'hora':
            return TarifaHora;
        case 'dia_meta':
            return TarifaDiaMeta;
    }
}
/** Criterio de calce contra atributos del cuartel. "*" calza todo. */
export const CriterioTarifa = z.record(z.string(), z.string());
export const TarifaInput = z
    .object({
    tarifario_id: z.string().uuid(),
    labor_codigo: LaborCodigo,
    criterio: CriterioTarifa.default({}),
    prioridad: z.number().int().min(0).default(100),
})
    .and(ParametrosTarifa);
export const ExcepcionTarifaInput = z.object({
    tarifa_id: z.string().uuid(),
    ambito_tipo: z.enum(['sociedad', 'predio', 'cuartel', 'cuadrilla']),
    ambito_id: z.string().uuid(),
    parametros: z.record(z.string(), z.unknown()),
    motivo: z.string().min(20),
    vigencia_desde: z.string().date(),
    vigencia_hasta: z.string().date().nullable(),
});
//# sourceMappingURL=tarifas.js.map